import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAttrs, computed } from 'vue';
  import { IProgram } from '@/types/program';
  import OnGoingProgram from '@/templates/on-going-program/index-view.vue';
  // import Shops from '@/templates/shop/index-view.vue';

  interface IAttrs {
    program?: IProgram;
    [key: string]: any;
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const attrs: IAttrs = useAttrs();

  const RenderComponent = computed(() => {
    const { program } = attrs;
    if (program) {
      // OnGoingProgram 这个模板可以配置为只有部分区域是可以自定义的
      if (program.show_fixed_content) {
        return OnGoingProgram;
      }
    }
    // TODO: 判断是Shop首页
    // return Shop;
    return 'div';
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(RenderComponent)), _normalizeProps(_guardReactiveProps(_unref(attrs))), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})